import { render, staticRenderFns } from "./overviewBox.vue?vue&type=template&id=1e65f67b&scoped=true&"
import script from "./overviewBox.vue?vue&type=script&lang=js&"
export * from "./overviewBox.vue?vue&type=script&lang=js&"
import style0 from "./overviewBox.vue?vue&type=style&index=0&id=1e65f67b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65f67b",
  null
  
)

export default component.exports